import { FetchHttpClient, HttpApiClient } from "@effect/platform"
import { Client as DashApiClient } from "@superwall/api/dash-api/client"
import { Context, Effect, Layer, Option, pipe } from "effect"
import { getAntiCSRFToken } from "@blitzjs/auth"

export { DashApiClient }
export const DashApiClientLive = DashApiClient.layer({
  baseUrl: "/",
  apiKey: Option.none(),
  additionalHeaders: () => {
    return {
      "anti-csrf": getAntiCSRFToken(),
    }
  },
}).pipe(Layer.provide(FetchHttpClient.layer), Layer.orDie)

//
//
//

import { OpenRevenueApi } from "@open-revenue/api/schema"

export const makeOpenRevenueClient = HttpApiClient.make(OpenRevenueApi, {
  baseUrl: "/",
})

export class OpenRevenueClient extends Context.Tag("@services/OpenRevenueClient")<
  OpenRevenueClient,
  Effect.Effect.Success<typeof makeOpenRevenueClient>
>() {
  static readonly Live = pipe(makeOpenRevenueClient, Layer.effect(this))
}

// export const makeClientReactQuery = make(Api, {
//   baseUrl: "/",
// });

// export class ClientReactQuery extends Context.Tag("@services/ClientReactQuery")<
//   ClientReactQuery,
//   Effect.Effect.Success<typeof makeClientReactQuery>
// >() {
//   static readonly Live = pipe(makeClientReactQuery, Layer.effect(this));
// }
